import React from 'react';
import PropTypes from 'prop-types';
import { SuiLabel } from '@splashthat/sui';

import AlignLeft from 'common/icons/AlignLeft';
import AlignCenter from 'common/icons/AlignCenter';
import AlignRight from 'common/icons/AlignRight';
import AlignFull from 'common/icons/AlignFull';

import { LEFT, CENTER, RIGHT, FULL } from 'common/entities/form/styleConfiguration/constants';
import CustomElementTypeTabsSelector from '../CustomElementTypeTabsSelector';

const LEFT_LABEL = 'Left';
const CENTER_LABEL = 'Center';
const RIGHT_LABEL = 'Right';
const FULL_LABEL = 'Full';

const getAlignmentTabs = (allowFullWidth) =>
    [
        {
            icon: AlignLeft,
            label: LEFT_LABEL,
            value: LEFT,
        },
        {
            icon: AlignCenter,
            label: CENTER_LABEL,
            value: CENTER,
        },
        {
            icon: AlignRight,
            label: RIGHT_LABEL,
            value: RIGHT,
        },
        allowFullWidth && {
            icon: AlignFull,
            label: FULL_LABEL,
            value: FULL,
        },
    ].filter(Boolean);

const AlignmentEditor = (props) => (
    <React.Fragment>
        {props.label && <SuiLabel text={props.label} />}
        <CustomElementTypeTabsSelector
            tabs={getAlignmentTabs(props.allowFullWidth)}
            value={props.position}
            onChange={props.onChangePosition}
            qaId={props.qaId}
        />
    </React.Fragment>
);

AlignmentEditor.propTypes = {
    position: PropTypes.string.isRequired,
    onChangePosition: PropTypes.func.isRequired,
    qaId: PropTypes.string.isRequired,
    label: PropTypes.string,
    allowFullWidth: PropTypes.bool,
};

AlignmentEditor.defaultProps = {
    label: undefined,
    allowFullWidth: false,
};

export default AlignmentEditor;
